module.exports = __webpack_public_path__ + "static/media/RI-D4-11.1-082.ef9c51cf.webp";